import React from 'react';
import styled from 'styled-components';

import { DisplaySetSuggestionList, DisplaySuggestion } from '../candidate-ai/candidateAiSuggestions.types';
import { CandidateType } from '../candidates/Candidates.types';

import { CandidateAiScalarRows, SuggestionReviewProps } from './CandidateAiScalarRows';
import { SuggestionListItems } from './CandidateAiSetSuggestionGroup';

const RejectedList = styled.div`
  .cv-suggestions-rejected-hint {
    margin: 0 0 8px;
    color: #64748b;
    font-size: 14px;
  }
  .cv-suggestions-rejected-label {
    margin: 20px 0 4px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #526174;
  }
`;

type CandidateAiRejectedSuggestionsProps = SuggestionReviewProps & {
  candidate: CandidateType;
  rows: DisplaySuggestion[];
  lists: DisplaySetSuggestionList[];
};

// Content of the Rejected tab: out of counts and bulk actions, but each item can still be accepted.
export const CandidateAiRejectedSuggestions: React.FC<CandidateAiRejectedSuggestionsProps> = ({
  candidate,
  rows,
  lists,
  ...reviewProps
}) => (
  <RejectedList>
    <p className="cv-suggestions-rejected-hint">Not saved to the record. Accept any you want to keep.</p>
    <CandidateAiScalarRows rows={rows} {...reviewProps} />
    {lists.map((list) => (
      <div key={list.field}>
        <h3 className="cv-suggestions-rejected-label">{list.label}</h3>
        <SuggestionListItems candidate={candidate} list={list} rejected {...reviewProps} />
      </div>
    ))}
  </RejectedList>
);
